<style lang="less">
    .gantt_dialog {
        width: 340px;
    }
    .btn-top {
        align-items: center;
        display: flex;
        .right {
            margin-left: auto;
            color: #757575;
        }
    }
    .btn-wrap {
        margin-top: 16px;
        margin-bottom: 25px;
        padding: 16px;
        height: 304px;
        overflow-y: auto;
        border: 1px solid var(--border-color-box-6);
        border-radius: 6px;
        .btn-item + .btn-item {
            margin-top: 16px;
        }

        label {
            margin-left: 8px !important;
        }
    }
    .select_columnbox {
    }
    .select_columnbox label {
        margin-bottom: 5px;
    }
</style>

<template>
    <Dialog class="gantt_dialog" :title="$t('title')" :isShow="true" :mask="true" :showFooter="true" @ok="ok">
        <div class="select_columnbox">
            <div class="btn-top">
                <span style="margin-left: 0" class="dialog-btn" @click="showAll">{{ $t("showAll") }}</span>
                <span class="dialog-btn" @click="hideAll">{{ $t("hideAll") }}</span>
                <span class="right">{{ $t("showColumns", { totalNum: showTotalNum }) }}</span>
            </div>
            <div class="btn-wrap">
                <template v-for="(item, index) in SelectColumnConfigSorted">
                    <template v-if="item._colType !== 1">
                        <!--   不展示id    -->
                        <div class="btn-item">
                            <i-switch @on-change="onSwitchChange($event, index)" :disabled="item.disabled" :value="item.show" size="small" />
                            <label>{{ $t(item.value) }}</label>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    declare var EDGantt: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class GanttColumn extends Vue {
        SelectColumn: Array<string> = []; // 选择的列表
        SelectColumnConfig: Array<any> = [];

        get SelectColumnConfigSorted() {
            return this.SelectColumnConfig.sort((a, b) => a._colType - b._colType);
        }

        get showTotalNum() {
            return this.SelectColumnConfig.filter((a) => a.show).length - 1;
        }

        get showColIdArray() {
            return this.SelectColumnConfig.filter((item) => item.show).map((item) => item._colId);
        }
        onSwitchChange(show, index) {
            this.SelectColumnConfig[index].show = show;
            this.checkShowColIdArray();
        }

        checkShowColIdArray() {
            const iDIndex = this.SelectColumnConfig.findIndex((item) => item._colType === 1);
            const nameIndex = this.SelectColumnConfig.findIndex((item) => item._colType === 2);
            // 当展示数量小于2时 不隐藏任务名和id
            if (this.showColIdArray.length < 2) {
                setTimeout(() => {
                    this.SelectColumnConfig[iDIndex].show = true;
                    this.SelectColumnConfig[nameIndex].show = true;
                    this.SelectColumnConfig[iDIndex].disabled = true;
                    this.SelectColumnConfig[nameIndex].disabled = true;
                });
            } else {
                this.SelectColumnConfig[iDIndex].disabled = false;
                this.SelectColumnConfig[nameIndex].disabled = false;
            }
            if (this.showColIdArray.length === 2 && this.SelectColumnConfig[iDIndex].show) {
                this.SelectColumnConfig[iDIndex].disabled = true;
            }
            if (this.showColIdArray.length === 2 && this.SelectColumnConfig[nameIndex].show) {
                this.SelectColumnConfig[nameIndex].disabled = true;
            }
        }

        showAll() {
            this.SelectColumnConfig.forEach((item, index) => {
                this.SelectColumnConfig[index].show = true;
            });
            this.checkShowColIdArray();
        }

        hideAll() {
            this.SelectColumnConfig.forEach((item, index) => {
                this.SelectColumnConfig[index].show = false;
            });
            this.checkShowColIdArray();
        }

        showModel() {
            let pGantt: any = window["_view"].getGantt();
            if (pGantt) {
                /*
        key:col id  Edgantt.eCt
        value: local name
      
        */

                let DefaultMap = new Map();
                DefaultMap.set(2, this.$t("Task Name"));
                DefaultMap.set(3, this.$t("Start"));
                DefaultMap.set(4, this.$t("Finish"));
                DefaultMap.set(5, this.$t("Duration"));
                DefaultMap.set(6, this.$t("Complete"));
                DefaultMap.set(9, this.$t("RealStartDate"));
                DefaultMap.set(10, this.$t("RealFinishDate"));
                DefaultMap.set(12, this.$t("Priority"));
                DefaultMap.forEach((value, key) => {
                    this.SelectColumnConfig.push({
                        show: false,
                        _colId: key,
                        _colType: key,
                        value: value,
                        disabled: false,
                    });
                });

                pGantt._lstCols.forEach((item, index) => {
                    if (item._colId)
                        if (DefaultMap.has(item._colId)) {
                            let defaultObj = this.SelectColumnConfig.find((obj) => obj._colId == item._colId);
                            if (defaultObj) {
                                defaultObj.show = !item._isHiden;
                                defaultObj.value = item._name;
                            }
                        } else {
                            this.SelectColumnConfig.push({
                                show: !item._isHiden,
                                _colId: item._colId,
                                _colType: item._colType,
                                value: item._name,
                                disabled: false,
                            });
                        }
                });
                DefaultMap.clear();
            }
        }
        ok() {
            window["_view"].ganttManageColumn(this.showColIdArray);
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        keyboardEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }
        mounted() {
            this.showModel();
        }

        created() {
            document.addEventListener("keydown", this.keyboardEvent);
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.keyboardEvent);
        }
        checkCustomTextColumn() {
            // 改变工期
            // let data = parseFloat(this.$store.state.gantt.customTextColumnNum)
            // console.log("---------->>>",data)
            // window["_view"].ganttTaskOpe("RowHeight",data);
        }

        // 组件方法也可以直接声明为实例的方法
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
    }
</script>
<i18n>
{
  "zh": {
    "showColumns": "共显示{totalNum}列",
    "showAll": "显示全部",
    "hideAll": "隐藏全部",
    "title": "管理甘特图列",
    "ID": "任务ID",
    "Task Name": "任务名称",
    "Start": "开始时间",
    "Finish": "结束时间",
    "Duration": "工作日",
    "Complete": "完成",
    "Resource": "资源",
    "Cost": "费用",
    "Priority": "优先级",
    "Hyperlink": "超链接",
    "Symbols": "符号",
    "RealStartDate": "实际开始日期",
    "RealFinishDate": "实际完成日期",
    "RealDuration": "实际持续时间",
    "CustomText": "自定义文本",
    "CustomDate": "自定义日期",
    "CustomDuration": "自定义持续时间",
    "CustomCurrency": "自定义货币",
    "CustomPercent": "自定义百分比",
    "CustomNumber": "自定义数字"
  },
  "en": {
    "showColumns": "Show {totalNum} columns",
    "showAll": "Show All",
    "hideAll": "Hide All",
    "title": "Insert Gantt Chart",
    "ID": "ID",
    "Task Name": "Task Name",
    "Start": "Start Date",
    "Finish": "Finish Date",
    "Duration": "Duration",
    "Complete": "Complete",
    "Resource": "Resource",
    "Cost": "Cost",
    "Priority": "Priority",
    "Hyperlink": "Hyperlink",
    "Symbols": "Symbols",
    "RealStartDate": "Actual Start Date",
    "RealFinishDate": "Actual Finish Date",
    "RealDuration": "Actual Duration",
    "CustomText": "Custom Text",
    "CustomDate": "Custom Date",
    "CustomDuration": "Custom Duration",
    "CustomCurrency": "Custom Currency",
    "CustomPercent": "Custom Percentage",
    "CustomNumber": "Custom Number"
  },
  "jp": {
    "showColumns": "{totalNum} 列を表示",
    "showAll": "すべて表示",
    "hideAll": "すべて非表示",
    "title": "ガントチャートを挿入",
    "ID": "ID",
    "Task Name": "ミッション名",
    "Start": "開始時間",
    "Finish": "終了時間",
    "Duration": "期間",
    "Complete": "完了",
    "Resource": "リソース",
    "Cost": "費用",
    "Priority": "優先順位",
    "Hyperlink": "ハイパーリンク",
    "Symbols": "記号",
    "RealStartDate": "実際の開始日",
    "RealFinishDate": "実際の完了日",
    "RealDuration": "実際の期間",
    "CustomText": "テキストをカスタマイズ",
    "CustomDate": "日付をカスタマイズ",
    "CustomDuration": "期間をカスタマイズ",
    "CustomCurrency": "通貨をカスタマイズ",
    "CustomPercent": "パーセンテージをカスタマイズ",
    "CustomNumber": "数字をカスタマイズ"
  },
  "fr": {
    "showColumns": "Afficher {totalNum} colonnes",
    "showAll": "Afficher tout",
    "hideAll": "Masquer tout",
    "title": "Insérer un diagramme de Gantt",
    "ID": "ID",
    "Task Name": "nom de la mission",
    "Start": "Date de début",
    "Finish": "Date de fin",
    "Duration": "Durée",
    "Complete": "Achevé",
    "Resource": "Ressource",
    "Cost": "Coût",
    "Priority": "Priorité",
    "Hyperlink": "Hyperlien",
    "Symbols": "Symboles",
    "RealStartDate": "Date de Début Réelle",
    "RealFinishDate": "Date de Fin Réelle",
    "RealDuration": "Durée Réelle",
    "CustomText": "Texte Personnalisé",
    "CustomDate": "Date Personnalisée",
    "CustomDuration": "Durée Personnalisée",
    "CustomCurrency": "Devise Personnalisée",
    "CustomPercent": "Pourcentage Personnalisé",
    "CustomNumber": "Numéro Personnalisé"
  },
  "de": {
    "showColumns": "{totalNum} Spalten anzeigen",
    "showAll": "Alle anzeigen",
    "hideAll": "Alle ausblenden",
    "title": "Gantt-Diagramm einfügen",
    "ID": "ID",
    "Task Name": "Missionsname",
    "Start": "Startdatum",
    "Finish": "Enddatum",
    "Duration": "Dauerzeit",
    "Complete": "Abgeschlossen",
    "Resource": "Ressource",
    "Cost": "Kosten",
    "Priority": "Priorität",
    "Hyperlink": "Hyperlink",
    "Symbols": "Symbol",
    "RealStartDate": "Tatsächliches Startdatum",
    "RealFinishDate": "Tatsächliches Enddatum",
    "RealDuration": "Tatsächliche dauer",
    "CustomText": "Benutzerdefinierter Text",
    "CustomDate": "Benutzerdefiniertes Datum",
    "CustomDuration": " Benutzerdefinierte Dauerzeit",
    "CustomCurrency": " Benutzerdefinierte Währung",
    "CustomPercent": "Benutzerdefinierte Prozente",
    "CustomNumber": "Benutzerdefinierte Nummer"
  },
  "es": {
    "showColumns": "Mostrar {totalNum} columnas",
    "showAll": "Mostrar todo",
    "hideAll": "Ocultar todo",
    "title": "Insertar el gráfico de Gantt",
    "ID": "ID",
    "Task Name": "nombre de la misión",
    "Start": "Fecha de inicio",
    "Finish": "Fecha de finalización",
    "Duration": "Duración",
    "Complete": "Completo",
    "Resource": "Recurso",
    "Cost": "Costo",
    "Priority": "Prioridad",
    "Hyperlink": "Hipervínculo",
    "Symbols": "Símbolos",
    "RealStartDate": "Fecha de inicio real",
    "RealFinishDate": "Fecha de finalización real",
    "RealDuration": "Duración real",
    "CustomText": "Texto personalizado",
    "CustomDate": "Fecha personalizada",
    "CustomDuration": "Duración personalizada",
    "CustomCurrency": "Moneda personalizada",
    "CustomPercent": "Porcentaje personalizado",
    "CustomNumber": "Número personalizado"
  },
  "pt": {
    "showColumns": "Mostrar {totalNum} colunas",
    "showAll": "Mostrar Tudo",
    "hideAll": "Ocultar Tudo",
    "title": "Inserir Gráfico de Gantt",
    "ID": "ID",
    "Task Name": "nome da missão",
    "Start": "Data Inicial",
    "Finish": "Data Final",
    "Duration": "Duração",
    "Complete": "Completo",
    "Resource": "Recurso",
    "Cost": "Custo",
    "Priority": "Prioridade",
    "Hyperlink": "Hiperligação",
    "Symbols": "Símbolos",
    "RealStartDate": "Data Inicial Real",
    "RealFinishDate": "Data Final Real",
    "RealDuration": "Duração Real",
    "CustomText": "Texto Personalizado",
    "CustomDate": "Data Personalizada",
    "CustomDuration": "Duração Personalizada",
    "CustomCurrency": "Moeda Personalizada",
    "CustomPercent": "Percentagem Personalizada",
    "CustomNumber": "Número Personalizado"
  },
  "it": {
    "showColumns": "Mostra {totalNum} colonne",
    "showAll": "Mostra tutto",
    "hideAll": "Nascondi tutto",
    "title": "Inserisci Diagramma di Gantt",
    "ID": "ID",
    "Task Name": "nome della missione",
    "Start": "Data di Inizio",
    "Finish": "Data di Fine",
    "Duration": "Durata",
    "Complete": "Completa",
    "Resource": "Risorse",
    "Cost": "Costi",
    "Priority": "Priorità",
    "Hyperlink": "Collegamento",
    "Symbols": "Simboli",
    "RealStartDate": "Data di Inizio Effettiva",
    "RealFinishDate": "Data di Fine Effettiva",
    "RealDuration": "Durata Effettiva",
    "CustomText": "Testo Personalizzato",
    "CustomDate": "Data Personalizzata",
    "CustomDuration": "Durata Personalizzata",
    "CustomCurrency": "Valuta Personalizzata",
    "CustomPercent": "Percentuale Personalizzata",
    "CustomNumber": "Numero Personalizzato"
  },
  "tw": {
    "showColumns": "顯示 {totalNum} 個欄",
    "showAll": "顯示全部",
    "hideAll": "隱藏全部",
    "title": "插入甘特圖列",
    "ID": "ID",
    "Task Name": "任务名称",
    "Start": "開始時間",
    "Finish": "結束時間",
    "Duration": "持續時間",
    "Complete": "完成",
    "Resource": "資源",
    "Cost": "費用",
    "Priority": "優先級",
    "Hyperlink": "超連結",
    "Symbols": "符號",
    "RealStartDate": "實際開始日期",
    "RealFinishDate": "實際完成日期",
    "RealDuration": "實際持續日期",
    "CustomText": "自定義文本",
    "CustomDate": "自定義日期",
    "CustomDuration": "自定義持續時間",
    "CustomCurrency": "自定義貨幣",
    "CustomPercent": "自定義百分比",
    "CustomNumber": "自定義數字"
  },
  "kr": {
    "showColumns": "{totalNum}개 열 표시",
    "showAll": "모두 표시",
    "hideAll": "모두 숨기기",
    "title": "간트 차트 삽입",
    "ID": "ID",
    "Task Name": "임무명",
    "Start": "시작 날짜",
    "Finish": "종료 날짜",
    "Duration": "지속 시간",
    "Complete": "완료",
    "Resource": "자원",
    "Cost": "비용",
    "Priority": "우선 순위",
    "Hyperlink": "하이퍼링크",
    "Symbols": "심볼",
    "RealStartDate": "실제 시작 날짜",
    "RealFinishDate": "실제 완료 날짜",
    "RealDuration": "실제 지속 기간",
    "CustomText": "사용자 정의 텍스트",
    "CustomDate": "사용자 정의 날짜",
    "CustomDuration": "사용자 정의 지속 기간",
    "CustomCurrency": "사용자 정의 화폐",
    "CustomPercent": "사용자 정의 퍼센트",
    "CustomNumber": "사용자 정의 숫자"
  }
}
</i18n>
